import type { PropTypes } from './UserProfileNotFound.types';
import type { ReactElement } from 'react';

import { Button, Flex, Heading, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../../hooks/reduxHooks';
import { useWindowDimensions } from '../../../hooks/useWindowDimensions';

import styles from './UserProfileNotFound.module.css';

const IMAGE_WIDTH_MOBILE = 198;
const IMAGE_HEIGHT_MOBILE = 148;
const IMAGE_WIDTH_DESKTOP = 428;
const IMAGE_HEIGHT_DESKTOP = 318;

export function UserProfileNotFound(props: PropTypes): ReactElement {
  const { username } = props;
  const { isDarkMode } = useAppSelector((state) => state.settings);
  const { isMobile } = useWindowDimensions();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navigateToHome = () => navigate('/');

  return (
    <Flex direction="column" align="center" gap="5" py={{ initial: '6', sm: '9' }}>
      <img
        src={`/imgs/profile/profile-not-found-${isDarkMode ? 'dark' : 'light'}.png`}
        alt="profile not found"
        width={isMobile ? IMAGE_WIDTH_MOBILE : IMAGE_WIDTH_DESKTOP}
        height={isMobile ? IMAGE_HEIGHT_MOBILE : IMAGE_HEIGHT_DESKTOP}
      />
      <Flex direction="column" align="center" gap="2">
        <Heading size={{ initial: '6', sm: '8' }} align="center">
          {t('Oops! User profile not found')}
        </Heading>
        <Text size={{ initial: '3', sm: '4' }} color="gray" align="center">
          {t('The profile URL you entered does not exist: ')}
          {isMobile && <br />}
          {username}
          <br />
          {t('Please check the URL and try again.')}
        </Text>
      </Flex>
      <Button
        id="profile-not-found-back-to-home-button"
        variant="solid"
        color="cyan"
        radius="full"
        size={{ initial: '3', sm: '4' }}
        onClick={navigateToHome}
        className={styles.backButton}>
        {t('Back to home')}
      </Button>
    </Flex>
  );
}
